(function () {
    var module = angular.module('far.helpers.stripTagsFilter', []);

    module.filter('stripTags', stripTags);

    function stripTags() {
        return function(value) {
            if (!value) {
                return value;
            }

            return $($.parseHTML('<root>' + value + '</root>')).text();
        }
    }
})();
